import { Component } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { DocumentFormBase } from '../document-form.base';
import { dateValiditePjErrors } from '@lib/validators/date-validition-pj-errors-validators';
import { OuiDatePicker, OuiValidationError } from 'omnium-ui/form-field';
import moment from 'moment';

@Component({
  selector: 'app-document-form-synt-urssaf',
  standalone: true,
  imports: [OuiDatePicker],
  templateUrl: './document-form-synt-urssaf.component.html',
  styleUrl: './document-form-synt-urssaf.component.scss',
})
export class DocumentFormSyntUrssafComponent extends DocumentFormBase<SyntUrssafForm> {
  readonly dateValidationErrors: OuiValidationError[] = dateValiditePjErrors();

  override createForm(fb: NonNullableFormBuilder) {
    return createSyntUrssafForm(fb);
  }

  setDateFinDeValidite(newDate: moment.Moment | string | null) {
    if (newDate != null && typeof newDate != 'string') {
      const dateFinSyntUrssaf = moment(newDate).add(6, 'months').toDate();
      const newDateFin = newDate ? dateFinSyntUrssaf : undefined;

      this.form.get('dateFinValidite')?.setValue(newDateFin);
    }
  }
}

export function createSyntUrssafForm(fb: NonNullableFormBuilder) {
  return fb.group({
    dateDebutValidite: fb.control<Date | undefined>(undefined, [Validators.required]),
    dateFinValidite: fb.control<Date | undefined>(undefined),
  });
}

export type SyntUrssafForm = ReturnType<typeof createSyntUrssafForm>;
export type SyntUrssafFormValue = SyntUrssafForm['value'];
